<template>
	<div>
		<div class="TopSearch">
			<FromComm :FromArr="FromArr"></FromComm>
			<!--transform: translateY(60px);-->
			<div style="margin-right: 28px;top:24px;">
				<CommonBtngroup ref="QuotaBtngroup" :chackbox="true" checktitle="仅显示不匹配" marginRight="60px"
					:qhide="false" @select="handSearch" @reset="handReset" />
			</div>
		</div>
		<div class="BottomTable">
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="exportData"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="跟台图片下载" fontSize="14px" @btnclick="downloadData"
				:src="require('@/assets/channel/all-download.png')">
			</Commonbtn>
			<div class="Table" style="padding-right: 10px;">
				<Commontable ref="refTableCenter" width="100%" colnum=7 :loadingTable="false" :tableData="tableData"
					:headerData="headerData" height="100%" @Look="handLook" @handleSelectionChange="(e)=>selectIds = e"
					@onRowClick="handRowClick">
				</Commontable>
				<div class="pagination">
					<Pagination ref="invPagination" type='allColor' :pageSize="query.pageSize"
						@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
					</Pagination>
				</div>
			</div>
			<div class="Table" style="padding-right: 10px;padding-bottom: 24px;" v-if="tableData2.length">
				<Commontable ref="refTableCenter" width="100%" colnum=7 :loadingTable="false" :tableData="tableData2"
					:headerData="headerData2" height="100%">
				</Commontable>
			</div>
		</div>
		<DialogFrom width="1000px" title="打卡详情" :OKASCAN="false" :dialogVisible="dialogVisible"
			@cancel="dialogVisible = false" @dialogOK="dialogVisible = false">
			<div class="DialogContent" v-if="detailInfo">
				<div class="cont-item">
					<div class="item-key">医&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;院：</div>
					<div class="item-val">{{detailInfo.HospitalName}}</div>
				</div>
				<div class="cont-images" v-if="detailInfo.BSurgeryRemark">
					<div class="image-title">术前备注：</div>
					<div class="image-title">{{detailInfo.BSurgeryRemark}}</div>
				</div>
				<div class="cont-images" style="align-items:flex-start;" v-if="detailInfo.ImageList_2001.length">
					<div class="image-title">术前照片：</div>
					<el-image v-for="(it,ix) in detailInfo.ImageList_2001" class="image" fit="cover" :src="it.FileUrl"
						:key="ix" :preview-src-list="detailInfo.ImageList_2001.map(it=>it.FileUrl)" />
				</div>
				<div class="cont-images" v-if="detailInfo.MSurgeryRemark">
					<div class="image-title">术中备注：</div>
					<div class="image-title">{{detailInfo.MSurgeryRemark}}</div>
				</div>
				<div class="cont-images" style="align-items:flex-start;" v-if="detailInfo.ImageList_2002.length">
					<div class="image-title">术中照片：</div>
					<el-image v-for="(it,ix) in detailInfo.ImageList_2002" class="image" fit="cover" :src="it.FileUrl"
						:key="ix" :preview-src-list="detailInfo.ImageList_2002.map(it=>it.FileUrl)" />
				</div>
				<div class="cont-images" v-if="detailInfo.ASurgeryRemark">
					<div class="image-title">术后备注：</div>
					<div class="image-title">{{detailInfo.ASurgeryRemark}}</div>
				</div>
				<div class="cont-images" style="align-items:flex-start;" v-if="detailInfo.ImageList_2003.length">
					<div class="image-title">术后照片：</div>
					<el-image v-for="(it,ix) in detailInfo.ImageList_2003" class="image" fit="cover" :src="it.FileUrl"
						:key="ix" :preview-src-list="detailInfo.ImageList_2003.map(it=>it.FileUrl)" />
				</div>
			</div>
		</DialogFrom>
	</div>
</template>

<script>
	import FromComm from './components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../components/commongroup.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import Commontable from '../../../../components/common-table.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import FromArr from './FormData/FromArrHistory'
	import headerData from './TableData/headerData'
	import utils from "../../../../common/utils";
	import {
		GetSfClockInList,
		ExportSfClockIn,
		DownloadSfClockIn,
		GetHelperClockInStatus,
		GetHelperClockInDetail
	} from '@/api/newsapi'
	import {
		InventoryClassList
	} from '@/api/home'
	export default {
		props: {
			auth: Array
		},
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			DialogFrom,
			Pagination,
			Commontable
		},
		computed: {
			menusData() {
				return this.$store.state.MenusData.Menus;
			}
		},
		data() {
			return {
				total: 0,
				query: {
					pageIndex: 1,
					pageSize: 15,
					UnDownload: 1
				},
				FromArr: [],
				tableData: [],
				headerData: [],
				selectIds: [], //选中的id 
				dialogVisible: false,
				detailInfo: null, //详情
				headerData2: [{
						prop: "InvName",
						label: "产品名称",
					}, {
						prop: "InvAddCode",
						label: "产品型号",
					},
					{
						prop: "Quantity",
						label: "数量",
					}
				],
				tableData2: []
			}
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.inventoryClassList();
			this.getHelperClockInStatus();
			this.getData();
		},
		methods: {
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.FromArr[0].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.FromArr[0].options.push(obj)
					})
				}
			},
			// 状态下拉
			async getHelperClockInStatus() {
				let {
					code,
					data
				} = await GetHelperClockInStatus({})
				if (code == 0) {
					this.FromArr[5].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.FromArr[5].options.push(obj)
					})
				}
			},
			async getData() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data
				} = await GetSfClockInList(this.query)
				loading.close();
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data;
				}
			},
			handLook(e) {
				this.detailInfo = e;
				this.dialogVisible = true;
			},
			// 导出
			async exportData() {
				this.query.pageIndex = 1;
				this.query.InvClass = this.FromArr[0].modelvalue;
				this.query.SalesManName = this.FromArr[1].modelvalue;
				this.query.YearMonth = this.FromArr[2].modelvalue;
				this.query.CreateTime1 = this.FromArr[3].StartTime;
				this.query.CreateTime2 = this.FromArr[3].EndTime;
				this.query.HospitalName = this.FromArr[4].modelvalue;
				this.query.Status = this.FromArr[5].modelvalue;
				this.query.CICode = this.FromArr[6].modelvalue;
				this.query.UnMatchDistrict = this.$refs.QuotaBtngroup.checkeds == true ? 1 : "";

				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await ExportSfClockIn(this.query)
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `跟台打卡列表${str}`, "xlsx")
					loading.close();
				} else {
					// 返回json
					this.$message.warning('导出失败');
					loading.close();
				}

			},
			//批量打包下载
			async downloadData() {
				if (!this.selectIds.length) {
					this.$message.warning('请勾选需要下载的数据');
					return;
				}
				const loading = this.$loading({
					lock: true,
					text: '正在下载...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await DownloadSfClockIn({
					CIMIDs: this.selectIds.map(it => it.CIMID)
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `跟台打卡照片${str}`, "rar")
					loading.close();
				} else {
					// 返回json
					this.$message.warning('导出失败');
					loading.close();
				}
			},
			handSearch() {
				this.query.pageIndex = 1;
				this.query.InvClass = this.FromArr[0].modelvalue;
				this.query.SalesManName = this.FromArr[1].modelvalue;
				this.query.YearMonth = this.FromArr[2].modelvalue;
				this.query.CreateTime1 = this.FromArr[3].StartTime;
				this.query.CreateTime2 = this.FromArr[3].EndTime;
				this.query.HospitalName = this.FromArr[4].modelvalue;
				this.query.Status = this.FromArr[5].modelvalue;
				this.query.CICode = this.FromArr[6].modelvalue;
				this.query.UnMatchDistrict = this.$refs.QuotaBtngroup.checkeds == true ? 1 : "";
				this.getData();
			},
			handReset() {
				this.query.pageIndex = 1;
				this.$refs.QuotaBtngroup.checkeds = false;
				this.FromArr.map((item, index) => {
					if (index == 2) {
						item.StartTime = '';
						item.EndTime = '';
					}
					item.modelvalue = ''
					return item;
				})
			},
			handleCurrentChange(e) {
				this.query.pageIndex = e
				this.getData()
			},
			handleSizeChange(e) {
				this.query.pageSize = e
				this.getData()
			},
			async handRowClick(e) {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data
				} = await GetHelperClockInDetail({
					CIMID: e.CIMID
				})
				loading.close();
				if (code == 0) {
					this.tableData2 = data;
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.TopSearch {
		height: 210px;
		margin: 0px 0px 8px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background: rgb(255, 255, 255);

		.btngroup {
			position: relative;
			bottom: 40px;
		}
	}

	.BottomTable {
		margin-bottom: 14px;
		box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 4px 0px;
		margin-top: 10px;
		background: rgb(255, 255, 255);
	}

	.DialogContent {
		min-height: 500px;

		.cont-item {
			display: flex;
			align-items: center;

			.item-key {
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 18px;
				color: #666666;
			}

			.item-val {
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 18px;
				color: #333333;
			}
		}

		.cont-images {
			display: flex;
			align-items: center;
			padding: 12px 0px;

			.image-title {
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 18px;
				color: #666666;
			}

			.image {
				width: 150px;
				height: 150px;
				border-radius: 12px;
				margin: 0px 16px 16px 0px;
			}
		}
	}
</style>